import {ColorSchemeType, UITheme} from 'epic-diesel-common/src/models/cms/Theme';
import {Map} from 'immutable';

export type UIThemeMap = Map<keyof UITheme, UITheme[keyof UITheme]>;

interface UIThemes {
    [ColorSchemeType.light]: UIThemeMap;
    [ColorSchemeType.dark]: UIThemeMap;
}

export const uiThemes: UIThemes = {
    [ColorSchemeType.light]: Map<keyof UITheme, UITheme[keyof UITheme]>({
        uiPrimaryText: '#121212',
        uiPrimaryBg: '#d2d2d2',
        uiSecondaryBg: '#8f8f8f',
        uiTertiaryBg: '#ddd',
        buttonPrimaryBg: '#f5ca23'
    }),
    [ColorSchemeType.dark]: Map<keyof UITheme, UITheme[keyof UITheme]>({
        uiPrimaryText: '#fff',
        uiPrimaryBg: '#121212',
        uiSecondaryBg: '#202020',
        uiTertiaryBg: '#2b2b2b',
        buttonPrimaryBg: '#0078f2'
    })
};

export function getUiTheme(theme: string): UIThemeMap {
    // defaults to dark theme
    return uiThemes[theme] || uiThemes[ColorSchemeType.dark];
}
